export function isItalianDevice() {
  return navigator.language === "it-IT";
}
